import { Badge } from "@mui/material";
import withStyles from "@mui/styles/withStyles";

const TabBadge = withStyles(theme => ({
  badge: {
    right: -14,
    top: 14,
    border: `2px solid ${theme.palette.background.paper}`,
  },
}))(Badge);

export default TabBadge;
